import { render, staticRenderFns } from "./cuotiFbjlu.vue?vue&type=template&id=31e365d0&scoped=true"
import script from "./cuotiFbjlu.vue?vue&type=script&lang=js"
export * from "./cuotiFbjlu.vue?vue&type=script&lang=js"
import style0 from "./cuotiFbjlu.vue?vue&type=style&index=0&id=31e365d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e365d0",
  null
  
)

export default component.exports